// extracted by mini-css-extract-plugin
module.exports = {"list":"ContactList_list__2WeP_","item":"ContactList_item__mwfdY","btn":"ContactList_btn__3Lp81"};